module.exports = __webpack_public_path__ + "static/media/icon-penny.7e9bba53.svg";